import { render, staticRenderFns } from "./modal-inlandsfluege-bearbeiten.vue?vue&type=template&id=a0587b92&scoped=true"
import script from "./modal-inlandsfluege-bearbeiten.vue?vue&type=script&lang=js"
export * from "./modal-inlandsfluege-bearbeiten.vue?vue&type=script&lang=js"
import style0 from "./modal-inlandsfluege-bearbeiten.vue?vue&type=style&index=0&id=a0587b92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0587b92",
  null
  
)

export default component.exports